/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const deleteContentResponseDataDeletionCountMin = 0;

export const DeleteContentResponse = zod.object({
  data: zod.object({
    deletedContentUuids: zod
      .array(zod.uuid().describe('UUID v4 identifier'))
      .describe('Every content version removed, descendants included.'),
    deletedLineageUuids: zod.array(zod.uuid().describe('UUID v4 identifier')),
    deletionCount: zod.int().min(deleteContentResponseDataDeletionCountMin),
    idempotencyKey: zod.uuid().describe('UUID v4 identifier'),
    operationId: zod.uuid().describe('Identifies the committed deletion.'),
    replayed: zod
      .boolean()
      .describe(
        'True when served from the stored receipt of an earlier identical request rather than a new deletion.',
      ),
  }),
});

export type DeleteContentResponse = zod.input<typeof DeleteContentResponse>;
export type DeleteContentResponseOutput = zod.output<typeof DeleteContentResponse>;
